<template>
  <div style="margin-left: 5%; margin-right: 5%; align-content: center;">
    <h2 style="text-align:center">Medidas e Manejos</h2>
    <v-row class="mt-6">
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[0]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[1]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[2]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[3]"></noticeCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[4]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[5]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[6]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[7]"></noticeCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[8]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[9]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[10]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[11]"></noticeCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
        <noticeCard class="card" :notice="notice[12]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col
        style="visibility:hidden;"
        cols="12"
        xs="auto"
        sm="auto"
        md="auto"
        lg="auto"
      >
        <noticeCard class="card" :notice="notice[12]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col
        style="visibility:hidden;"
        cols="12"
        xs="auto"
        sm="auto"
        md="auto"
        lg="auto"
      >
        <noticeCard class="card" :notice="notice[12]"></noticeCard>
      </v-col>
      <v-spacer />
      <v-col
        style="visibility:hidden;"
        cols="12"
        xs="auto"
        sm="auto"
        md="auto"
        lg="auto"
      >
        <noticeCard class="card" :notice="notice[12]"></noticeCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import content from "../../../../styles/assets/medidas_manejo.json";
export default {
  name: "defaultNotice",
  components: {
    noticeCard: () => import("../noticeCard/index.vue")
  },
  data: () => ({
    notice: [
      {
        title: content[0].title,
        paragraph: content[0].paragraph,
        capa: content[0].capa,
        link: "/info",
        capa2: content[0].capa2,
        images: content[0].images,
        description: content[0].description
      },
      {
        title: content[1].title,
        paragraph: content[1].paragraph,
        capa: content[1].capa,
        link: "/info",
        capa2: content[1].capa2,
        images: content[1].images,
        description: content[1].description
      },
      {
        title: content[2].title,
        paragraph: content[2].paragraph,
        capa: content[2].capa,
        link: "/info",
        capa2: content[2].capa2,
        images: content[2].images,
        description: content[2].description
      },
      {
        title: content[3].title,
        paragraph: content[3].paragraph,
        capa: content[3].capa,
        link: "/info",
        capa2: content[3].capa2,
        images: content[3].images,
        description: content[3].description
      },
      {
        title: content[4].title,
        paragraph: content[4].paragraph,
        capa: content[4].capa,
        link: "/info",
        capa2: content[4].capa2,
        images: content[4].images,
        description: content[4].description
      },
      {
        title: content[5].title,
        paragraph: content[5].paragraph,
        capa: content[5].capa,
        link: "/info",
        capa2: content[5].capa2,
        images: content[5].images,
        description: content[5].description
      },
      {
        title: content[6].title,
        paragraph: content[6].paragraph,
        capa: content[6].capa,
        link: "/info",
        capa2: content[6].capa2,
        images: content[6].images,
        description: content[6].description
      },
      {
        title: content[7].title,
        paragraph: content[7].paragraph,
        capa: content[7].capa,
        link: "/info",
        capa2: content[7].capa2,
        images: content[7].images,
        description: content[7].description
      },
      {
        title: content[8].title,
        paragraph: content[8].paragraph,
        capa: content[8].capa,
        link: "/info",
        capa2: content[8].capa2,
        images: content[8].images,
        description: content[8].description
      },
      {
        title: content[9].title,
        paragraph: content[9].paragraph,
        capa: content[9].capa,
        link: "/info",
        capa2: content[9].capa2,
        images: content[9].images,
        description: content[9].description
      },
      {
        title: content[10].title,
        paragraph: content[10].paragraph,
        capa: content[10].capa,
        link: "/info",
        capa2: content[10].capa2,
        images: content[10].images,
        description: content[10].description
      },
      {
        title: content[11].title,
        paragraph: content[11].paragraph,
        capa: content[11].capa,
        link: "/info",
        capa2: content[11].capa2,
        images: content[11].images,
        description: content[11].description
      },
      {
        title: content[12].title,
        paragraph: content[12].paragraph,
        capa: content[12].capa,
        link: "/info",
        capa2: content[12].capa2,
        images: content[12].images,
        description: content[12].description
      }
    ]
  })
};
</script>

<style scoped>
@media only screen and (max-width: 1430px) {
  .card {
    width: 250px;
  }
}
@media only screen and (min-width: 1430px) {
  .card {
    width: 300px;
  }
}
</style>
